import { CollectionPreview } from 'types/Collection';
import { MarketNft } from 'types/Nft';
import { PreviewMediaAsset } from 'types/media';

import NftTag from './NftTag';
import Flex from './base/Flex';
import Message from './base/Message';
import Text from './base/Text';

type ExplainUnlistingProps = {
  nft: {
    name: MarketNft['name'];
    collection: CollectionPreview;
  } | null;
  media: PreviewMediaAsset | null;
};

export default function ExplainUnlisting(props: ExplainUnlistingProps) {
  const { nft, media } = props;
  return (
    <Flex css={{ flexDirection: 'column', gap: '$6' }}>
      <Text color="dim" lineHeight={2}>
        Unlisting this NFT will remove all prices, any association with a
        gallery and will remove the NFT from escrow to return it to your wallet.
      </Text>
      {!nft ? (
        <NftTag.Skeleton />
      ) : (
        <NftTag name={nft.name} media={media} collection={nft.collection} />
      )}
      <Message
        variant="subtle"
        title="Please note"
        message="— even when unlisted, the NFT will still remain on your profile. If you’d like to delete it, you will need to burn it."
      />
    </Flex>
  );
}
